export default "__VITE_ASSET__BYvPnm6l__"